import React from 'react';
import { styled } from 'styletron-react';
import { Radio } from 'baseui/radio';
import { Col, Row } from 'react-bootstrap';
import { useStyletron } from 'baseui';

import { TechemTheme } from '@techem/techem-theme';

interface IconRadioProperties {
  mainIconSrc: string;
  optionTitle: string;
  radioValue: string;
  wasSelected: any;
  isChecked: boolean;
  iconMaxSize?: string;
  additionalTestId?: string;
}

const MainIcon = styled('img', (props: any) => ({
  maxHeight: props.$iconMaxSize ? props.$iconMaxSize : '59px',
  maxWidth: props.$iconMaxSize ? props.$iconMaxSize : '141px',
  margin: '0 auto 23px auto'
}));

const TitleView = styled('div', {
  '@media (min-width: 768px)': {
    textAlign: 'center'
  },
  // Only useable here.. If we use the className for margin nothing happens
  marginTop: 'auto',
  marginBottom: 'auto',
  fontSize: '0.875rem'
});

const RadioWrapperRow = styled(Row, {
  height: '60px',
  '@media (max-width: 767px)': {
    backgroundColor: TechemTheme.colors.backgroundSecondary,
    borderRadius: '6px'
  }
});

const NestedFlexBox = styled('div', {
  flex: '1',
  outline: 'none', // Remove default focus outline
  transition: 'border 0.2s ease-in-out', // Smooth transition for border changes
  border: `2px solid transparent`, // Default border (transparent)
  borderRadius: '6px', // Optional: Add rounded corners
  ':focus': {
    border: `2px solid ${TechemTheme.colors.primary}`
  }
});

export default function IconRadio(props: IconRadioProperties) {
  const [css] = useStyletron();

  return (
    <NestedFlexBox
      tabIndex={0}
      className="d-flex flex-wrap justify-content-center"
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        props.wasSelected(props.radioValue);
        e.currentTarget.blur(); // remove focus after click
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          props.wasSelected(props.radioValue);
        }
      }}
      data-gi={`icon-radio${
        props.additionalTestId !== undefined ? ' ' + props.additionalTestId : ''
      }`}
    >
      <Row className={css({ flexBasis: '100%' }) + ' d-none d-md-block justify-content-center'}>
        <Col xs="auto" className="d-flex">
          <MainIcon
            $iconMaxSize={props.iconMaxSize}
            src={props.mainIconSrc}
            alt={props.optionTitle}
          />
        </Col>
      </Row>
      <Row className={css({ flexBasis: '100%' }) + ' d-none d-md-block justify-content-center'}>
        <Col xs="auto" className="text-center my-auto">
          <TitleView className="mx-0">{props.optionTitle}</TitleView>
        </Col>
      </Row>
      <RadioWrapperRow
        className={css({ flexBasis: '100%' }) + ' my-1 justify-content-center align-self-flex-end'}
      >
        <Col xs="auto" className="d-flex">
          <Radio
            tabIndex={'-1'}
            isFocusVisible={true}
            value={props.radioValue}
            checked={props.isChecked}
            overrides={{
              Root: {
                style: ({ $theme }) => ({
                  marginTop: '6px',
                  marginRight: 'auto',
                  marginBottom: '6px',
                  marginLeft: 'auto'
                })
              },
              Label: {
                style: ({ $theme }) => ({ display: 'none' })
              }
            }}
          />
        </Col>
        <Col xs className="d-block d-md-none ps-0">
          <div className="d-flex w-100 h-100 mx-0 my-auto">
            <TitleView>{props.optionTitle}</TitleView>
          </div>
        </Col>
      </RadioWrapperRow>
    </NestedFlexBox>
  );
}
